import { Component } from '@theme/component';

/**
 * Mobile drawer Level-1 secondary section (Tienda / Atención / Lista de deseos /
 * Mi cuenta). The `mobile-menu-link` blocks are rendered once at section scope
 * (the hidden `.header-mega-banner-source`), so the drawer can't read them at
 * Liquid render time. This clones each `.drawer-secondary-source__item` into the
 * `<drawer-secondary>` container (the grey block in L1). Idempotent + observed so
 * it survives the header re-rendering via the Section Rendering API.
 *
 * @extends {Component}
 */
class DrawerSecondary extends Component {
  /** @type {MutationObserver | null} */
  #observer = null;

  connectedCallback() {
    super.connectedCallback();
    this.#adopt();
    this.#observer = new MutationObserver(() => this.#adopt());
    this.#observer.observe(this, { childList: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #adopt = () => {
    const root = this.closest('#header-component') ?? document;
    const source = root.querySelector('.header-mega-banner-source');
    if (!source) return;
    const items = [...source.querySelectorAll('.drawer-secondary-source__item')];
    if (items.length === 0) return;
    // Idempotent: only rewrite when not already populated correctly.
    if (this.childElementCount === items.length) return;

    this.#observer?.disconnect();
    this.replaceChildren(...items.map((item) => item.cloneNode(true)));
    if (this.isConnected) this.#observer?.observe(this, { childList: true });
  };
}

if (!customElements.get('drawer-secondary')) {
  customElements.define('drawer-secondary', DrawerSecondary);
}
